import { CREHANA_BASE_URL_PRD } from "@crehana/constants";
const MAIN_FOOTER_PAGE_KEY = 'main-footer';
const COMPANY_LINKS = [
    {
        label: 'COMPANY_ABOUT',
        href: `${CREHANA_BASE_URL_PRD}/sobre-nosotros/`
    },
    {
        label: 'COMPANY_SIGN_UP',
        href: `${CREHANA_BASE_URL_PRD}/entrar/`
    }
];
const PRODUCT_LINKS = [
    {
        label: 'PRODUCT_DEVELOPMENT',
        href: `${CREHANA_BASE_URL_PRD}/desarrollo-equipos/`
    },
    {
        label: 'PRODUCT_WORK_ENVIRONMENT',
        href: `${CREHANA_BASE_URL_PRD}/clima-laboral/`
    },
    {
        label: 'PRODUCT_PERFORMANCE',
        href: `${CREHANA_BASE_URL_PRD}/evaluaciones-de-desempeno/`
    }
];
const RESOURCES_LINKS = [
    {
        label: 'RESOURCES_BLOG',
        href: `${CREHANA_BASE_URL_PRD}/blog/`
    },
    {
        label: 'RESOURCES_PODCAST',
        href: 'https://open.spotify.com/show/4e4HZuphxpKot9xfaqXt9k'
    },
    {
        label: 'RESOURCES_DOWNLOABLES',
        href: `${CREHANA_BASE_URL_PRD}/business/descargables/`
    },
    {
        label: 'RESOURCES_COURSES',
        href: `${CREHANA_BASE_URL_PRD}/cursos-online/`
    },
    {
        label: 'RESOURCES_YOUTUBE',
        href: 'https://www.youtube.com/watch?v=dtcQyOsuL3g'
    }
];
const HELP_LINKS = [
    {
        label: 'HELP_PRIVACY',
        href: `${CREHANA_BASE_URL_PRD}/legal/politicas-de-privacidad/`
    },
    {
        label: 'HELP_COOKIES',
        href: `${CREHANA_BASE_URL_PRD}/legal/politica-de-cookies/`
    },
    {
        label: 'HELP_ARCO',
        href: `${CREHANA_BASE_URL_PRD}/legal/solicitud-arco/`
    },
    {
        label: 'HELP_TERMS',
        href: `${CREHANA_BASE_URL_PRD}/legal/terminos-y-condiciones/`
    },
    {
        label: 'HELP_CLAIMS_BOOK',
        href: `${CREHANA_BASE_URL_PRD}/libro-reclamaciones/`
    }
];
export { COMPANY_LINKS, HELP_LINKS, MAIN_FOOTER_PAGE_KEY, PRODUCT_LINKS, RESOURCES_LINKS };
